import React from 'react';
import PropTypes from 'prop-types';
import {Typography, Stack, Divider} from '@mui/material';
import {capitalize} from 'lodash';
import {renderAmount} from '../../../../util';
import {Modal} from '../../../../components/Modal';

export function ExchangeRateModal({exchangeRateFx, open, onClose}) {
  if (!exchangeRateFx) return null;

  const balanceSheeStackiff = Math.round(
    exchangeRateFx.beginning_balance_rate_difference_contribution
  );
  const postingDiff = Math.round(
    exchangeRateFx.net_posting_rate_difference_contribution
  );
  const sum = balanceSheeStackiff + postingDiff;

  return (
    <Modal
      keepMounted={false}
      open={open}
      onClose={onClose}
      title={capitalize(exchangeRateFx.pli_name)}
    >
      <Divider color="#DFE6E3" />
      <Stack gap={3} p={3}>
        <Typography sx={{color: '#687B7A'}}>
          Effect of exchange rate changes on cash
        </Typography>
        <Stack direction="row" justifyContent="space-between" gap={5}>
          <Typography sx={{color: '#162523'}}>
            Beginning Balance Rate Difference Contribution
          </Typography>
          <Typography sx={{color: '#162523', fontWeight: 600}}>
            {balanceSheeStackiff ? renderAmount(balanceSheeStackiff) : 0}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={5}>
          <Typography sx={{color: '#162523'}}>
            Net Posting Rate Difference Contribution
          </Typography>
          <Typography sx={{color: '#162523', fontWeight: 600}}>
            {postingDiff ? renderAmount(postingDiff) : 0}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={5}>
          <Typography sx={{color: '#162523'}}>
            Total FX impact (CTA Contribution)
          </Typography>
          <Typography sx={{color: '#162523', fontWeight: 600}}>
            {sum ? renderAmount(sum, true) : 0}
          </Typography>
        </Stack>
        <Typography
          sx={{
            fontSize: 12,
            color: '#687B7A',
          }}
        >
          This amount adjusts for the effects of rate differences during the
          period and the impact to Cumulative Translation Adjustment (CTA)
          account in the consolidated balance sheet. The adjustment calculated
          for the Effect of Exchange Rate on Cash row adds or subtracts any CTA
          amount as necessary and can be traced to the CTA AUDIT report in
          netsuite.
        </Typography>
      </Stack>
    </Modal>
  );
}

ExchangeRateModal.propTypes = {
  exchangeRateFx: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
